const Loader = ({
  size = 50,
  showText = false,
  text = "Loading...",
  className = "",
  color,
}) => {
  // Get current theme from document
  const isDarkTheme = document.documentElement.classList.contains("theme-dark");

  // Determine loader color based on theme
  let loaderColor;
  if (isDarkTheme) {
    loaderColor = "#FF1CF7"; // Primary color for dark theme
  } else {
    loaderColor = "#7B02CB"; // Primary color for light theme
  }

  const sizeMap = {
    30: "w-[30px] h-[30px]",
    40: "w-[40px] h-[40px]",
    50: "w-[50px] h-[50px]",
    60: "w-[60px] h-[60px]",
  };

  const sizeClass = sizeMap[size] || `w-[${size}px] h-[${size}px]`;

  // Default to py-10 if no vertical padding class is provided in className to maintain backward compatibility
  // but allow it to be overridden if specified (e.g., 'py-0')
  const defaultPadding = className.includes("py-") ? "" : "py-10";

  return (
    <div
      className={`flex flex-col items-center justify-center ${defaultPadding} ${className}`}
    >
      {/* Spinner Circle */}
      <div
        className={`${sizeClass} animate-spin rounded-full border-4`}
        style={{
          borderColor: "var(--color-stroke-01)",
          borderTopColor: color || loaderColor,
        }}
      ></div>

      {/* Optional Loading Text */}
      {showText && (
        <p
          className="mt-4 text-sm"
          style={{
            color: "var(--color-content-01)",
          }}
        >
          {text}
        </p>
      )}
    </div>
  );
};

export default Loader;
